import agent from './angent'
import { layout } from './layout'
import { oauth } from './oauth'
import { service } from './service'
import { system } from './system'

const config = {
  system,
  layout,
  service,
  oauth,
  agent,
}

export default config
